import { useState } from "react";
import { useDispatch } from "react-redux";
import { content_groupActions } from "../actions";

const DEFAULT_NOTIFICATION = "show_content_notification";

// Owns the state + handlers needed to open the ContentList popup for a single
// content group. `contentListProps` is a ready-to-spread bundle for <ContentList />,
// so any screen can show a card popup without re-wiring the same plumbing.
function useContentListPopupHook({ content_popup_notification = DEFAULT_NOTIFICATION } = {}) {
  const dispatch = useDispatch();
  const [contentGroupPopUp, setContentGroupPopUp] = useState({ id: null, show: false });
  const [workspaceId, setWorkspaceId] = useState();

  const openContentGroupPopUp = ({ content_group_id, workspace_id }) => {
    setWorkspaceId(workspace_id);
    setContentGroupPopUp({ id: content_group_id, show: true });
  };

  const handleCloseContentGroupPopUp = () => {
    setContentGroupPopUp({ id: null, show: false });
  };

  const handleInlineEdit = (handleOnBlur, values, content_group_id) => {
    dispatch(content_groupActions.inlineEditContentGroup(handleOnBlur, values, content_group_id, workspaceId));
  };

  const contentListProps = {
    content_group_id: contentGroupPopUp.id,
    workspace_id: workspaceId,
    handleCloseContentGroupPopUp,
    handleInlineEdit,
    setContentGroupPopUp,
    content_popup_notification,
  };

  return {
    contentGroupPopUp,
    openContentGroupPopUp,
    handleCloseContentGroupPopUp,
    contentListProps,
  };
}

export default useContentListPopupHook;
